module.exports = __webpack_public_path__ + "static/img/qrcg.a73fb882.png";